var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L24 24L1 47","stroke":"#FF00FF","strokeWidth":"2"}));
}

ArrowRightInline.defaultProps = {"width":"26","height":"48","viewBox":"0 0 26 48","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
